/** Deal segmentation (Míša's bodový model): the vocabulary shared by scorer, API and UI. */
export const SEGMENTS = ['investicni', 'rezidencni', 'nezarazeno'] as const;
export type Segment = (typeof SEGMENTS)[number];

export const SEGMENT_LABELS: Record<Segment, string> = {
  investicni: 'Investiční',
  rezidencni: 'Rezidenční',
  nezarazeno: 'Nezařazeno',
};

export const SIGNAL_SIDES = ['inv', 'res'] as const;
export type SignalSide = (typeof SIGNAL_SIDES)[number];

export const SIGNAL_SOURCES = ['field', 'title', 'text', 'registry', 'llm'] as const;
export type SignalSource = (typeof SIGNAL_SOURCES)[number];

/** One piece of evidence for a side; the scorer sums them per side. */
export interface Signal {
  key: string;
  side: SignalSide;
  source: SignalSource;
  evidence?: string;
}
